module.exports = __webpack_public_path__ + "img/faq-icon.d4aa442b.svg";